import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const ecoUpgradedService = {
    getAllUpgradeds,
    getUpgraded,
    updateUpgraded,
    createUpgraded,
    updateUpgradedStatus 
};

const MODULE = {
  UPGRADED: 'eco-upgradeds',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllUpgradeds(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.UPGRADED}`, requestOptions)
  }

  export function getUpgraded(id) {
    return apiHelper(API_URL).get(`/${MODULE.UPGRADED}/${id}`)
  }

  export function updateUpgraded(data) {

    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.UPGRADED}/${data.id}`, requestOptions)
  }

  export function createUpgraded(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.UPGRADED}`, requestOptions)
  }

  export function updateUpgradedStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
  
    return apiHelper(API_URL).patch(`/${MODULE.UPGRADED}/${data.id}`, requestOptions)
  }